module.exports = __webpack_public_path__ + "img/logo.e9592a38.jpg";